import { ApolloError } from "@apollo/client";
import { useMemo } from "react";

import { ISelectOption } from "src/core/constants/options";
import { useCountriesListQuery } from "src/core/gql/graphql";

export const useCountryOptions = (): {
  countryOptions: ISelectOption[];
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data: countryList, loading, error } = useCountriesListQuery();

  const countryOptions: ISelectOption[] = useMemo(() => {
    return (
      countryList?.listElements
        ?.filter(
          (
            country
          ): country is {
            __typename: "Country";
            id: string;
            code: string;
            name: string;
            alpha3: string;
          } => country.__typename === "Country"
        )
        .map((country) => ({
          value: country.code,
          label: country.name,
        })) ?? []
    );
  }, [countryList]);

  return { countryOptions, loading, error };
};
